import groq from 'groq';

import { ASSET, GIF, RICH_TEXT } from '../common';

export const TEXT = groq`
  title,
  description[] {
    ${RICH_TEXT}
  },
  "layout": coalesce(layout, 'left'),
  media[0] {
    _type,
    _type == 'altImage' => { ${ASSET} },
    _type == 'gif' => { ${GIF} }
  }
`;

export const TEXT_BLOCK = groq`
  _type == 'textBlock' => {
    ${TEXT}
  }
`;
